import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Vehicle Categories questions
export const vehicleCategoriesMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-vc-1',
    text: {
      en: 'What is the speed limit for motorcycles on motorways in the Netherlands?',
      nl: 'Wat is de snelheidslimiet voor motorfietsen op snelwegen in Nederland?',
      ar: 'ما هو حد السرعة للدراجات النارية على الطرق السريعة في هولندا؟'
    },
    options: [
      { id: 'q-vc-1o1', text: { en: '100 km/h', nl: '100 km/u', ar: '100 كم/س' } },
      { id: 'q-vc-1o2', text: { en: '120 km/h', nl: '120 km/u', ar: '120 كم/س' } },
      { id: 'q-vc-1o3', text: { en: '130 km/h', nl: '130 km/u', ar: '130 كم/س' } },
      { id: 'q-vc-1o4', text: { en: '140 km/h', nl: '140 km/u', ar: '140 كم/س' } }
    ],
    correctAnswerId: 'q-vc-1o1',
    explanation: {
      en: 'Motorcycles have the same speed limit as cars on motorways in the Netherlands, which is 100 km/h during good weather conditions (reduced from 130 km/h in 2020).',
      nl: 'Motorfietsen hebben dezelfde snelheidslimiet als auto\'s op snelwegen in Nederland, namelijk 100 km/u bij goed weer (verlaagd van 130 km/u in 2020).',
      ar: 'للدراجات النارية نفس حد السرعة مثل السيارات على الطرق السريعة في هولندا، وهو 100 كم/س في ظروف الطقس الجيد (تم تقليله من 130 كم/س في عام 2020).'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-2',
    text: {
      en: 'What is the speed limit for trucks on motorways in the Netherlands?',
      nl: 'Wat is de snelheidslimiet voor vrachtwagens op snelwegen in Nederland?',
      ar: 'ما هو حد السرعة للشاحنات على الطرق السريعة في هولندا؟'
    },
    options: [
      { id: 'q-vc-2o1', text: { en: '80 km/h', nl: '80 km/u', ar: '80 كم/س' } },
      { id: 'q-vc-2o2', text: { en: '90 km/h', nl: '90 km/u', ar: '90 كم/س' } },
      { id: 'q-vc-2o3', text: { en: '100 km/h', nl: '100 km/u', ar: '100 كم/س' } },
      { id: 'q-vc-2o4', text: { en: '110 km/h', nl: '110 km/u', ar: '110 كم/س' } }
    ],
    correctAnswerId: 'q-vc-2o1',
    explanation: {
      en: 'Trucks have a speed limit of 80 km/h on motorways in the Netherlands, regardless of the weather conditions.',
      nl: 'Vrachtwagens hebben een snelheidslimiet van 80 km/u op snelwegen in Nederland, ongeacht de weersomstandigheden.',
      ar: 'للشاحنات حد سرعة 80 كم/س على الطرق السريعة في هولندا، بغض النظر عن ظروف الطقس.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-3',
    text: {
      en: 'What is the speed limit for buses on motorways in the Netherlands?',
      nl: 'Wat is de snelheidslimiet voor bussen op snelwegen in Nederland?',
      ar: 'ما هو حد السرعة للحافلات على الطرق السريعة في هولندا؟'
    },
    options: [
      { id: 'q-vc-3o1', text: { en: '80 km/h', nl: '80 km/u', ar: '80 كم/س' } },
      { id: 'q-vc-3o2', text: { en: '90 km/h', nl: '90 km/u', ar: '90 كم/س' } },
      { id: 'q-vc-3o3', text: { en: '100 km/h', nl: '100 km/u', ar: '100 كم/س' } },
      { id: 'q-vc-3o4', text: { en: '110 km/h', nl: '110 km/u', ar: '110 كم/س' } }
    ],
    correctAnswerId: 'q-vc-3o1',
    explanation: {
      en: 'Buses have a speed limit of 80 km/h on motorways in the Netherlands, the same as trucks.',
      nl: 'Bussen hebben een snelheidslimiet van 80 km/u op snelwegen in Nederland, hetzelfde als vrachtwagens.',
      ar: 'للحافلات حد سرعة 80 كم/س على الطرق السريعة في هولندا، نفس الشاحنات.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-4',
    text: {
      en: 'What is the speed limit for mopeds on roads in the Netherlands?',
      nl: 'Wat is de snelheidslimiet voor bromfietsen op wegen in Nederland?',
      ar: 'ما هو حد السرعة للدراجات البخارية على الطرق في هولندا؟'
    },
    options: [
      { id: 'q-vc-4o1', text: { en: '25 km/h', nl: '25 km/u', ar: '25 كم/س' } },
      { id: 'q-vc-4o2', text: { en: '30 km/h', nl: '30 km/u', ar: '30 كم/س' } },
      { id: 'q-vc-4o3', text: { en: '45 km/h', nl: '45 km/u', ar: '45 كم/س' } },
      { id: 'q-vc-4o4', text: { en: '50 km/h', nl: '50 km/u', ar: '50 كم/س' } }
    ],
    correctAnswerId: 'q-vc-4o3',
    explanation: {
      en: 'Mopeds have a speed limit of 45 km/h on roads in the Netherlands, unless otherwise indicated by traffic signs.',
      nl: 'Bromfietsen hebben een snelheidslimiet van 45 km/u op wegen in Nederland, tenzij anders aangegeven door verkeersborden.',
      ar: 'للدراجات البخارية حد سرعة 45 كم/س على الطرق في هولندا، ما لم يذكر خلاف ذلك في علامات المرور.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-5',
    text: {
      en: 'What is the speed limit for tractors on roads in the Netherlands?',
      nl: 'Wat is de snelheidslimiet voor tractoren op wegen in Nederland?',
      ar: 'ما هو حد السرعة للجرارات على الطرق في هولندا؟'
    },
    options: [
      { id: 'q-vc-5o1', text: { en: '15 km/h', nl: '15 km/u', ar: '15 كم/س' } },
      { id: 'q-vc-5o2', text: { en: '25 km/h', nl: '25 km/u', ar: '25 كم/س' } },
      { id: 'q-vc-5o3', text: { en: '30 km/h', nl: '30 km/u', ar: '30 كم/س' } },
      { id: 'q-vc-5o4', text: { en: '40 km/h', nl: '40 km/u', ar: '40 كم/س' } }
    ],
    correctAnswerId: 'q-vc-5o2',
    explanation: {
      en: 'Tractors have a speed limit of 25 km/h on roads in the Netherlands, unless they have special permission for higher speeds.',
      nl: 'Tractoren hebben een snelheidslimiet van 25 km/u op wegen in Nederland, tenzij ze speciale toestemming hebben voor hogere snelheden.',
      ar: 'للجرارات حد سرعة 25 كم/س على الطرق في هولندا، ما لم يكن لديها إذن خاص بسرعات أعلى.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-6',
    text: {
      en: 'Which lane should motorcycles use on a three-lane motorway?',
      nl: 'Welke rijstrook moeten motorfietsen gebruiken op een driestrooks snelweg?',
      ar: 'أي ممر يجب أن تستخدمه الدراجات النارية على طريق سريع بثلاثة ممرات؟'
    },
    options: [
      {
        id: 'q-vc-6o1',
        text: {
          en: 'The right lane only',
          nl: 'Alleen de rechterrijstrook',
          ar: 'الممر الأيمن فقط'
        }
      },
      {
        id: 'q-vc-6o2',
        text: {
          en: 'The left lane only',
          nl: 'Alleen de linkerrijstrook',
          ar: 'الممر الأيسر فقط'
        }
      },
      {
        id: 'q-vc-6o3',
        text: {
          en: 'Any lane they choose',
          nl: 'Elke rijstrook die ze kiezen',
          ar: 'أي ممر يختارونه'
        }
      },
      {
        id: 'q-vc-6o4',
        text: {
          en: 'The middle lane only',
          nl: 'Alleen de middelste rijstrook',
          ar: 'الممر الأوسط فقط'
        }
      }
    ],
    correctAnswerId: 'q-vc-6o3',
    explanation: {
      en: 'Motorcycles can use any lane on a motorway, just like cars. They should follow the same lane discipline rules.',
      nl: 'Motorfietsen kunnen elke rijstrook op een snelweg gebruiken, net als auto\'s. Ze moeten dezelfde rijstrookdisciplineregels volgen.',
      ar: 'يمكن للدراجات النارية استخدام أي ممر على الطريق السريع، تماما مثل السيارات. يجب أن تتبع نفس قواعد انضباط الممرات.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-7',
    text: {
      en: 'Which lane should trucks use on a three-lane motorway?',
      nl: 'Welke rijstrook moeten vrachtwagens gebruiken op een driestrooks snelweg?',
      ar: 'أي ممر يجب أن تستخدمه الشاحنات على طريق سريع بثلاثة ممرات؟'
    },
    options: [
      {
        id: 'q-vc-7o1',
        text: {
          en: 'The right lane only',
          nl: 'Alleen de rechterrijstrook',
          ar: 'الممر الأيمن فقط'
        }
      },
      {
        id: 'q-vc-7o2',
        text: {
          en: 'The left lane only',
          nl: 'Alleen de linkerrijstrook',
          ar: 'الممر الأيسر فقط'
        }
      },
      {
        id: 'q-vc-7o3',
        text: {
          en: 'Any lane they choose',
          nl: 'Elke rijstrook die ze kiezen',
          ar: 'أي ممر يختارونه'
        }
      },
      {
        id: 'q-vc-7o4',
        text: {
          en: 'The middle and right lanes',
          nl: 'De middelste en rechterrijstroken',
          ar: 'الممرات الوسطى واليمنى'
        }
      }
    ],
    correctAnswerId: 'q-vc-7o4',
    explanation: {
      en: 'Trucks should use the middle and right lanes on a three-lane motorway. They are not allowed to use the left lane for overtaking.',
      nl: 'Vrachtwagens moeten de middelste en rechterrijstroken gebruiken op een driestrooks snelweg. Ze mogen de linkerrijstrook niet gebruiken om in te halen.',
      ar: 'يجب على الشاحنات استخدام الممرات الوسطى واليمنى على طريق سريع بثلاثة ممرات. لا يسمح لها باستخدام الممر الأيسر للتجاوز.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-8',
    text: {
      en: 'What is the speed limit for cars towing trailers on motorways?',
      nl: 'Wat is de snelheidslimiet voor auto\'s die aanhangers trekken op snelwegen?',
      ar: 'ما هو حد السرعة للسيارات التي تجر مقطورات على الطرق السريعة؟'
    },
    options: [
      { id: 'q-vc-8o1', text: { en: '80 km/h', nl: '80 km/u', ar: '80 كم/س' } },
      { id: 'q-vc-8o2', text: { en: '90 km/h', nl: '90 km/u', ar: '90 كم/س' } },
      { id: 'q-vc-8o3', text: { en: '100 km/h', nl: '100 km/u', ar: '100 كم/س' } },
      { id: 'q-vc-8o4', text: { en: '110 km/h', nl: '110 km/u', ar: '110 كم/س' } }
    ],
    correctAnswerId: 'q-vc-8o2',
    explanation: {
      en: 'Cars towing trailers have a speed limit of 90 km/h on motorways in the Netherlands.',
      nl: 'Auto\'s die aanhangers trekken hebben een snelheidslimiet van 90 km/u op snelwegen in Nederland.',
      ar: 'للسيارات التي تجر مقطورات حد سرعة 90 كم/س على الطرق السريعة في هولندا.'
    },
    subject: 'Vehicle Categories'
  }
  ,
  {
    id: 'q-vc-9',
    text: {
      en: 'What is the minimum legal tread depth for car tyres in the Netherlands?',
      nl: 'Wat is de wettelijke minimale profieldiepte voor personenautobanden in Nederland?',
      ar: 'ما هي القيمة الدنيا القانونية لعمق مداس إطارات السيارات في هولندا؟'
    },
    options: [
      { id: 'q-vc-9o1', text: { en: '1.0 mm', nl: '1,0 mm', ar: '1.0 مم' } },
      { id: 'q-vc-9o2', text: { en: '1.6 mm', nl: '1,6 mm', ar: '1.6 مم' } },
      { id: 'q-vc-9o3', text: { en: '2.0 mm', nl: '2,0 mm', ar: '2.0 مم' } }
    ],
    correctAnswerId: 'q-vc-9o2',
    explanation: {
      en: 'The minimum legal tread depth for car tyres in the Netherlands is 1.6 mm. CBR recommends replacing tyres at 2 mm for better safety, especially in wet conditions.',
      nl: 'De wettelijke minimale profieldiepte voor personenautobanden in Nederland is 1,6 mm. Het CBR adviseert banden te vervangen bij 2 mm voor betere veiligheid, vooral bij nat weer.',
      ar: 'القيمة الدنيا القانونية لعمق مداس إطارات السيارات في هولندا هي 1.6 مم. توصي CBR باستبدال الإطارات عند 2 مم لسلامة أفضل، خصوصاً في الظروف الممطرة.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-10',
    text: {
      en: 'How often should you check the brake fluid level in your vehicle?',
      nl: 'Hoe vaak moet u het remvloeistofpeil controleren?',
      ar: 'كم مرة يجب أن تتحقق من مستوى سائل الفرامل في مركبتك؟'
    },
    options: [
      { id: 'q-vc-10o1', text: { en: 'Only when the brake warning light comes on', nl: 'Als het remwaarschuwingslampje gaat branden', ar: 'فقط عندما تنطفئ/تضيء لمبة تحذير الفرامل' } },
      { id: 'q-vc-10o2', text: { en: 'Regularly, as part of routine maintenance', nl: 'Regelmatig, als onderdeel van het onderhoud', ar: 'بشكل منتظم ضمن الصيانة الدورية' } },
      { id: 'q-vc-10o3', text: { en: 'Once every 5 years', nl: 'Eens per vijf jaar', ar: 'مرة كل 5 سنوات' } }
    ],
    correctAnswerId: 'q-vc-10o2',
    explanation: {
      en: 'Brake fluid should be checked regularly as part of routine vehicle maintenance. Low brake fluid can indicate worn brake pads or a leak, both of which affect safety.',
      nl: 'Controleer remvloeistof regelmatig bij het onderhoud. Te weinig remvloeistof kan wijzen op versleten remblokken of een lekkage; beide zijn onveilig.',
      ar: 'يجب فحص سائل الفرامل بانتظام ضمن الصيانة الدورية للمركبة. انخفاضه قد يشير إلى تآكل بطانات الفرامل أو وجود تسريب، وكلاهما يؤثر على السلامة.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-11',
    text: {
      en: 'When should you check the engine oil level?',
      nl: 'Wanneer moet u het motoroliepeil controleren?',
      ar: 'متى يجب أن تتحقق من مستوى زيت المحرك؟'
    },
    options: [
      { id: 'q-vc-11o1', text: { en: 'When the engine is running and warm', nl: 'Als de motor loopt en warm is', ar: 'عندما يكون المحرك يعمل وساخناً' } },
      { id: 'q-vc-11o2', text: { en: 'When the engine is cold and the car is on level ground', nl: 'Als de motor koud is en de auto op vlakke grond staat', ar: 'عندما يكون المحرك بارداً والسيارة على أرض مستوية' } },
      { id: 'q-vc-11o3', text: { en: 'Only at the annual APK inspection', nl: 'Alleen bij de jaarlijkse APK-keuring', ar: 'فقط أثناء فحص APK السنوي' } }
    ],
    correctAnswerId: 'q-vc-11o2',
    explanation: {
      en: 'Engine oil should be checked when the engine is cold and the vehicle is parked on level ground. This gives an accurate reading. Check regularly between services.',
      nl: 'Motorolie controleert u bij een koude motor op vlakke ondergrond voor een juiste meting. Controleer regelmatig tussen onderhoudsbeurten.',
      ar: 'يجب فحص زيت المحرك عندما يكون المحرك بارداً والسيارة متوقفة على أرض مستوية، لأن ذلك يعطي قراءة دقيقة. يُنصح بالفحص بانتظام بين مواعيد الصيانة.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-12',
    text: {
      en: 'When should you replace your windscreen wipers?',
      nl: 'Wanneer moet u uw ruitenwissers vervangen?',
      ar: 'متى يجب أن تستبدل مساحات/ممسحات الزجاج الأمامي؟'
    },
    options: [
      { id: 'q-vc-12o1', text: { en: 'Only when they stop working completely', nl: 'Pas als ze helemaal niet meer werken', ar: 'فقط عندما تتوقف عن العمل تماماً' } },
      { id: 'q-vc-12o2', text: { en: 'When they streak, smear, or no longer clear the windscreen properly', nl: 'Als ze strepen trekken, vegen of de voorruit niet meer goed vrijmaken', ar: 'عندما تترك خطوطاً/تمسح بشكل غير واضح أو لا تنظف الزجاج بشكل جيد' } },
      { id: 'q-vc-12o3', text: { en: 'Every 6 months regardless of condition', nl: 'Elke zes maanden, ongeacht de staat', ar: 'كل 6 أشهر بغض النظر عن الحالة' } }
    ],
    correctAnswerId: 'q-vc-12o2',
    explanation: {
      en: 'Replace windscreen wipers when they streak, smear, or fail to clear the windscreen properly. Good visibility is essential for safe driving, especially in rain.',
      nl: 'Vervang ruitenwissers als ze strepen trekken, slecht vegen of de voorruit niet helder houden. Goed zicht is essentieel voor veilig rijden, vooral bij regen.',
      ar: 'استبدل مساحات الزجاج الأمامي عندما تترك خطوطاً أو تمسح بشكل غير واضح أو تفشل في تنظيف الزجاج الأمامي بشكل مناسب. الرؤية الجيدة ضرورية للقيادة الآمنة، خصوصاً أثناء المطر.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-13',
    text: {
      en: 'Before driving at night, what should you check regarding your vehicle lighting?',
      nl: 'Wat moet u voor het nachtelijk rijden controleren aan de verlichting van uw voertuig?',
      ar: 'قبل القيادة ليلاً، ماذا يجب أن تتحقق من إضاءة مركبتك؟'
    },
    options: [
      { id: 'q-vc-13o1', text: { en: 'Only the headlights', nl: 'Alleen de koplampen', ar: 'فقط الأضواء الأمامية' } },
      { id: 'q-vc-13o2', text: { en: 'All lights: headlights, tail lights, indicators, and brake lights', nl: 'Alle lampen: koplampen, achterlichten, richtingaanwijzers en remlichten', ar: 'جميع الأضواء: الأضواء الأمامية، الخلفية، الإشارات، وأضواء الفرامل' } },
      { id: 'q-vc-13o3', text: { en: 'Lights are not necessary to check; they are always working', nl: 'Verlichting hoeft niet gecontroleerd te worden; die werkt altijd', ar: 'لا حاجة للفحص؛ الأضواء تعمل دائماً' } }
    ],
    correctAnswerId: 'q-vc-13o2',
    explanation: {
      en: 'Before driving at night, check that all lights work: headlights (dipped and main beam), tail lights, indicators, brake lights, and number plate light. Faulty lights are a safety risk.',
      nl: 'Controleer voor het nachtelijk rijden alle verlichting: grootlicht en dimlicht, achterlichten, richtingaanwijzers, remlichten en kentekenverlichting. Defecte lampen zijn een veiligheidsrisico.',
      ar: 'قبل القيادة ليلاً تأكد أن جميع الأضواء تعمل: الأضواء الأمامية (المنخفضة والعالية)، الأضواء الخلفية، إشارات الانعطاف، أضواء الفرامل، وإضاءة لوحة الأرقام. الأعطال في الأضواء تشكل خطراً على السلامة.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-14',
    text: {
      en: 'What is the minimum age requirement to drive a category B vehicle in the Netherlands?',
      nl: 'Wat is de minimumleeftijd om in Nederland een voertuig van categorie B te besturen?',
      ar: 'ما الحد الأدنى للعمر للقيادة بمركبة فئة B في هولندا؟'
    },
    options: [
      { id: 'q-vc-14o1', text: { en: '16 years', nl: '16 jaar', ar: '16 سنة' } },
      { id: 'q-vc-14o2', text: { en: '17 years', nl: '17 jaar', ar: '17 سنة' } },
      { id: 'q-vc-14o3', text: { en: '18 years', nl: '18 jaar', ar: '18 سنة' } }
    ],
    correctAnswerId: 'q-vc-14o3',
    explanation: {
      en: 'The minimum age to drive a category B vehicle (standard passenger car) in the Netherlands is 18 years. Supervised driving is allowed from age 17 under certain conditions.',
      nl: 'De minimumleeftijd voor categorie B (personenauto) in Nederland is 18 jaar. Begeleid rijden is vanaf 17 jaar mogelijk onder voorwaarden.',
      ar: 'الحد الأدنى لسن القيادة بمركبة فئة B (سيارة ركاب عادية) في هولندا هو 18 سنة. ويُسمح بالقيادة تحت الإشراف من عمر 17 سنة وفقاً لشروط معينة.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-15',
    text: {
      en: 'What is the maximum permitted mass (permissible gross vehicle weight rating) you can tow with a category B license?',
      nl: 'Wat is de maximale toegestane massa (maximaal toegestane rijklaar massa van de aanhangwagen) die u met een rijbewijs B mag trekken?',
      ar: 'ما هي الكتلة القصوى المسموح بها التي يمكنك سحبها بموجب رخصة فئة B؟'
    },
    options: [
      { id: 'q-vc-15o1', text: { en: 'Up to 750 kg without restrictions', nl: 'Tot 750 kg zonder extra bevoegdheid', ar: 'حتى 750 كغ دون قيود' } },
      { id: 'q-vc-15o2', text: { en: "Only trailers with a maximum mass of 50% of the vehicle's mass", nl: "Alleen aanhangwagens tot maximaal 50% van de massa van het trekkende voertuig", ar: 'فقط المقطورات التي لا تتجاوز كتلتها 50% من كتلة المركبة' } },
      { id: 'q-vc-15o3', text: { en: 'No trailers allowed', nl: 'Geen aanhangwagens toegestaan', ar: 'لا يسمح بأي مقطورة' } }
    ],
    correctAnswerId: 'q-vc-15o1',
    explanation: {
      en: 'With a category B license, you can tow a trailer with a maximum permissible gross vehicle weight rating of 750 kg without needing additional endorsements or license categories.',
      nl: 'Met rijbewijs B mag u een aanhangwagen trekken met een maximale toegestane massa van 750 kg zonder extra uitbreidingen op het rijbewijs.',
      ar: 'بترخيص فئة B يمكنك سحب مقطورة بحد أقصى لوزن المركبة الإجمالي المسموح به يبلغ 750 كغ دون الحاجة إلى ترخيص/إضافات إضافية.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-16',
    text: {
      en: 'What does category C1 vehicle license allow you to drive?',
      nl: 'Waarvoor geeft het rijbewijs categorie C1 bevoegdheid?',
      ar: 'ماذا يتيح ترخيص فئة C1 للقيادة؟'
    },
    options: [
      { id: 'q-vc-16o1', text: { en: 'Only passenger vehicles', nl: 'Alleen personenauto\'s', ar: 'فقط مركبات الركاب' } },
      { id: 'q-vc-16o2', text: { en: 'Vans and light trucks up to 7,500 kg permissible gross vehicle weight rating', nl: 'Bestelauto\'s en lichte vrachtauto\'s tot 7.500 kg maximale massa', ar: 'فان وشاحنات خفيفة حتى 7,500 كغ من الوزن الإجمالي المسموح' } },
      { id: 'q-vc-16o3', text: { en: 'Any heavy truck', nl: 'Elke zware vrachtauto', ar: 'أي شاحنة ثقيلة' } }
    ],
    correctAnswerId: 'q-vc-16o2',
    explanation: {
      en: 'Category C1 license allows you to drive vehicles (vans and light trucks) with a permissible gross vehicle weight rating between 3,500 kg and 7,500 kg. You must be at least 18 years old.',
      nl: 'Categorie C1 mag u besturen van voertuigen (bestellers/lichte vracht) met een maximale massa tussen 3.500 en 7.500 kg. Minimumleeftijd 18 jaar.',
      ar: 'ترخيص فئة C1 يتيح لك قيادة مركبات (فان وشاحنات خفيفة) بوزن إجمالي مسموح بين 3,500 كغ و7,500 كغ. يجب أن تكون على الأقل بعمر 18 سنة.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-17',
    text: {
      en: 'What is the minimum age to obtain a category A (motorcycle) license in the Netherlands?',
      nl: 'Wat is de minimumleeftijd voor een volledig rijbewijs categorie A (motorfiets) in Nederland?',
      ar: 'ما الحد الأدنى للعمر للحصول على رخصة فئة A (دراجة نارية) في هولندا؟'
    },
    options: [
      { id: 'q-vc-17o1', text: { en: '16 years', nl: '16 jaar', ar: '16 سنة' } },
      { id: 'q-vc-17o2', text: { en: '18 years', nl: '18 jaar', ar: '18 سنة' } },
      { id: 'q-vc-17o3', text: { en: '20 years', nl: '20 jaar', ar: '20 سنة' } }
    ],
    correctAnswerId: 'q-vc-17o2',
    explanation: {
      en: 'You must be at least 18 years old to obtain a full category A motorcycle license in the Netherlands. A restricted category A license (125cc max) is available from age 16.',
      nl: 'Voor een volledig rijbewijs categorie A moet u minimaal 18 jaar zijn. Een beperkte categorie A (max. 125 cc) is vanaf 16 jaar mogelijk.',
      ar: 'يجب أن تكون بعمر لا يقل عن 18 سنة للحصول على رخصة دراجة نارية كاملة فئة A في هولندا. وتتوفر رخصة فئة A المقيدة (بحد أقصى 125 سم مكعب) بدءاً من عمر 16 سنة.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-18',
    text: {
      en: 'What is the definition of a category M vehicle?',
      nl: 'Wat verstaat men onder een voertuig van categorie M?',
      ar: 'ما تعريف مركبة فئة M؟'
    },
    options: [
      { id: 'q-vc-18o1', text: { en: 'Mopeds and motorcycles with maximum 50cc engine', nl: 'Bromfietsen en lichte motorfietsen tot maximaal 50 cc', ar: 'دراجات هوائية/سكوتر خفيف ودراجات نارية بحد أقصى 50 سم³' } },
      { id: 'q-vc-18o2', text: { en: 'Motorcycles with maximum 125cc engine', nl: 'Motorfietsen tot maximaal 125 cc', ar: 'دراجات نارية بحد أقصى 125 سم³' } },
      { id: 'q-vc-18o3', text: { en: 'Heavy trucks', nl: 'Zware vrachtauto\'s', ar: 'الشاحنات الثقيلة' } }
    ],
    correctAnswerId: 'q-vc-18o1',
    explanation: {
      en: 'Category M vehicles include mopeds and small motorcycles with engines not exceeding 50cc and a maximum design speed of 45 km/h. You can drive category M vehicles from age 16.',
      nl: 'Categorie M omvat bromfietsen en lichte motorfietsen tot 50 cc met een constructiesnelheid van maximaal 45 km/u. Vanaf 16 jaar.',
      ar: 'تضم مركبات فئة M الدراجات البخارية/السكوتر الخفيف والدراجات النارية الصغيرة بمحركات لا تتجاوز 50 سم³ وبسرعة تصميم قصوى 45 كم/س. يمكنك قيادة مركبات فئة M من عمر 16 سنة.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-19',
    text: {
      en: 'What is the difference between category B and category B+E licenses?',
      nl: 'Wat is het verschil tussen rijbewijs categorie B en categorie BE?',
      ar: 'ما الفرق بين رخصتي فئة B وفئة B+E؟'
    },
    options: [
      { id: 'q-vc-19o1', text: { en: 'B+E allows towing trailers heavier than 750 kg', nl: 'BE mag zwaardere aanhangwagens trekken dan 750 kg', ar: 'B+E يسمح بسحب مقطورات أثقل من 750 كغ' } },
      { id: 'q-vc-19o2', text: { en: 'B+E allows driving vans', nl: 'BE mag bestelauto\'s besturen', ar: 'B+E يسمح بقيادة فان' } },
      { id: 'q-vc-19o3', text: { en: 'There is no difference', nl: 'Er is geen verschil', ar: 'لا يوجد فرق' } }
    ],
    correctAnswerId: 'q-vc-19o1',
    explanation: {
      en: 'Category B+E (B with trailer endorsement) allows drivers to tow trailers heavier than 750 kg and with a higher permissible gross vehicle weight rating. Category B alone limits trailer towing to 750 kg.',
      nl: 'Met BE (B met aanhangwagen) mag u zwaardere aanhangwagens en hogere massa\'s trekken dan met B alleen; met B geldt doorgaans de grens van 750 kg voor de aanhangwagen.',
      ar: 'تتيح رخصة B+E (B مع ملحق المقطورة) للسائق سحب مقطورات أثقل من 750 كغ وبوزن إجمالي مسموح أعلى. أما رخصة B وحدها فتقيّد سحب المقطورات حتى 750 كغ.'
    },
    subject: 'Vehicle Categories'
  },
  {
    id: 'q-vc-20',
    text: {
      en: 'What vehicles can you drive with a category D license?',
      nl: 'Welke voertuigen mag u met rijbewijs categorie D besturen?',
      ar: 'ما المركبات التي يمكنك قيادتها برخصة فئة D؟'
    },
    options: [
      { id: 'q-vc-20o1', text: { en: 'Buses and coaches with more than 8 passenger seats', nl: 'Bussen en touringcars met meer dan 8 zitplaatsen voor passagiers', ar: 'باصات وحافلات تتسع لأكثر من 8 مقاعد ركاب' } },
      { id: 'q-vc-20o2', text: { en: 'Heavy trucks and tractors', nl: 'Zware vrachtauto\'s en trekkers', ar: 'شاحنات ثقيلة وجرارات' } },
      { id: 'q-vc-20o3', text: { en: 'Only minibuses', nl: 'Alleen minibussen', ar: 'فقط الميني باصات' } }
    ],
    correctAnswerId: 'q-vc-20o1',
    explanation: {
      en: 'Category D license allows you to drive buses and coaches designed to carry more than 8 passengers. You must be at least 24 years old and have held a category B license for at least 2 years.',
      nl: 'Categorie D is voor bussen en touringcars voor meer dan 8 passagiers. Meestal minimaal 24 jaar en minstens 2 jaar rijbewijs B (naar de actuele wetgeving).',
      ar: 'تتيح رخصة فئة D قيادة الباصات والحافلات المصممة لنقل أكثر من 8 ركاب. يجب أن تكون بعمر لا يقل عن 24 سنة وأن تكون قد حصلت على رخصة فئة B لمدة لا تقل عن سنتين.'
    },
    subject: 'Vehicle Categories'
  }
];

























